export default __webpack_public_path__ + "static/media/5.8b5cf65d.jpg";